import React, { use, useEffect, useState } from "react";
import Highcharts, { pad } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more";
import SolidGauge from "highcharts/modules/solid-gauge";
import { useRouter } from "next/router";
import HighchartsExporting from "highcharts/modules/exporting";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";

function GauageChart({
  level,
  rank,
  levelKr,
  onlyRisk = false,
  size = 100,
  disabledStyle = false,
}: {
  level: string;
  rank: number;
  levelKr: string;
  onlyRisk?: boolean;
  size?: number;
  disabledStyle?: boolean;
}) {
  const router = useRouter();
  if (typeof Highcharts === "object") {
    HighchartsExporting(Highcharts);
    // highchartsMore(Highcharts);
    // SolidGauge(Highcharts);
  }
  const options = {
    chart: {
      type: "solidgauge",
      height: "100%",
      spacing: [0, 0, 0, 0], // 패딩 제거
      margin: [0, 0, 0, 0], // 마진 제거
      backgroundColor: "transparent",
    },
    title: null, // 타이틀 제거
    credits: {
      enabled: false, // "highcharts.com" 워터마크 제거
    },
    exporting: {
      enabled: false,
    },
    pane: {
      size: "100%", // 크기 조정
      startAngle: -140, // 반원 범위를 줄임
      endAngle: 140, // 반원 범위를 줄임
      background: [
        {
          backgroundColor: TAILWIND_TO_CSS["gray20"], // 차지 않은 부분의 배경색 설정
          borderRadius: 20,
          innerRadius: "90%",
          outerRadius: "100%",
          borderWidth: 0,
          shape: "arc",
        },
      ],

      center: ["50%", "50%"], // pane 중심 위치
    },
    tooltip: {
      enabled: false,
      // enabled: true,
      // useHTML: true,
      // borderWidth: 0,
    },
    yAxis: {
      min: 1,
      max: 100,
      stops: disabledStyle
        ? [
            [0, "#C0C0C0"],
            [1, "#C0C0C0"],
          ]
        : [
            [0, TAILWIND_TO_CSS["risk-green"]],
            [0.25, TAILWIND_TO_CSS["risk-green"]],
            [0.26, TAILWIND_TO_CSS["risk-yellow"]],
            [0.5, TAILWIND_TO_CSS["risk-yellow"]],
            [0.51, TAILWIND_TO_CSS["risk-orange"]],
            [0.75, TAILWIND_TO_CSS["risk-orange"]],
            [0.76, TAILWIND_TO_CSS["risk-red"]],
            [0.99, TAILWIND_TO_CSS["risk-red"]],
            [1, TAILWIND_TO_CSS["risk-red"]],
          ],
      lineWidth: 0,
      tickWidth: 0,
      minorTickInterval: null,
      tickAmount: 0, // 레이블 제거
      labels: {
        enabled: false, // 레이블 제거
      },
    },
    plotOptions: {
      solidgauge: {
        borderRadius: 50,
        dataLabels: {
          y: size === 80 ? -20 : -28,
          x: 0,
          borderWidth: 0,
          useHTML: true,
          format: `
            <div style="display:flex; flex-direction:column; justify-item:center; align-items:center; width:70px;">
            ${
              onlyRisk
                ? ""
                : `<span style="color:${
                    TAILWIND_TO_CSS["gray60"]
                  }; font-size: 13px; font-family: Pretendard; font-weight: 500; line-height: 20px; word-wrap: break-word;">${
                    router.locale === "ko" ? "리스크 등급" : "Risk Level"
                  }</span>`
            }
                <span style="color: ${TAILWIND_TO_CSS["gray80"]}; font-size: ${
            size === 80 ? "15px" : "20px"
          }; font-family: Pretendard; font-weight: 600; line-height: 28px; word-wrap: break-word;">${
            router.locale === "ko" ? levelKr : level
          }</span>
            </div>
            `,
        },
        // rounded: true, // 양 끝을 둥글게 설정
      },
    },
    series: [
      {
        name: "등수",
        data: [rank], // 게이지의 현재 값 설정 // 포트폴리오 리스크는 1~25가 안전, 26~50이 적정, 51~75가 주의, 76~100이 위험이기 때문에 101 - rnk로 안해도 됨
        innerRadius: "90.5%", // 두께를 얇게 설정
        outerRadius: "90.5%", // 두께를 얇게 설정
        color: disabledStyle ? "#C0C0C0" : undefined,
      },
    ],
  };

  const [isHighchartsLoaded, setHighchartsLoaded] = useState(false);

  useEffect(() => {
    // highchartsMore(Highcharts);
    // SolidGauge(Highcharts);

    const loadHighchartsModules = async () => {
      const Highcharts = await import("highcharts");
      const HighchartsMore = await import("highcharts/highcharts-more");
      const SolidGauge = await import("highcharts/modules/solid-gauge");
      const HighchartsExporting = await import("highcharts/modules/exporting");

      HighchartsMore.default(Highcharts);
      SolidGauge.default(Highcharts);
      HighchartsExporting.default(Highcharts);
      setHighchartsLoaded(true);
    };

    loadHighchartsModules();
  }, []);

  const sizestyle = `h-[${size}px] w-[${size}px]`;

  if (!isHighchartsLoaded) {
    return <div></div>;
  }
  return (
    <div className={`relative ${sizestyle}`}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}

const GauageChartMemo = React.memo(GauageChart);

export default GauageChartMemo;
